import React from "react";
import { parseAmount } from "../../lib/amount";
import { formatPayroll } from "../../lib/currency";

// Live dinar equivalent of a payroll amount typed in thousands: "25" -> "= 25,000 د.ع".
// Display only: the field's value and what gets saved are unchanged. Invalid/empty input shows nothing.
const DinarHint = ({ value, className = "mt-1 text-sm text-slate-600 tabular-nums" }) => {
  const parsed = parseAmount(value);
  if (!parsed.ok) return null;
  return (
    <p aria-live="polite" className={className}>
      = {formatPayroll(parsed.value)}
    </p>
  );
};

export default DinarHint;
